<template>
  <div class="orderView" v-loading.fullscreen.lock="fullLoading">

    <div class="block">
      <div class="block-head">
        {{$t('Reservation View')}}
      </div>
      <div class="block-content">
        <div class="view-main">
          <ul class="view-list">
            <li>
              <label>{{$t('Rate Name')}}:</label>
              <span>{{detail.rate_name}}</span>
            </li>
            <li>
              <label>{{$t('Room Type')}}:</label>
              <span>{{detail.room_type}}</span>
            </li>
            <li>
              <label>{{$t('First Name')}}:</label>
              <span>{{detail.first_name}}</span>
            </li>
            <li>
              <label>{{$t('Last Name')}}:</label>
              <span>{{detail.last_name}}</span>
            </li>
            <li>
              <label>{{$t('Arrival Date')}}:</label>
              <span>{{detail.arrival_date}}</span>
            </li>
            <li>
              <label>{{$t('Departure Date')}}:</label>
              <span>{{detail.departure_date}}</span>
            </li>
            <li>
              <label>{{$t('Adult Per Room')}}:</label>
              <span>{{detail.adult}}</span>
            </li>
            <li>
              <label>{{$t('Child Per Room')}}:</label>
              <span>{{detail.children}}</span>
            </li>
            <li>
              <label>{{$t('Hotel')}}: </label>
              <span>{{detail.hotel}}</span>
            </li>
            <li>
              <label>{{$t('Cell Phone')}}:</label>
              <span>{{detail.cell_phone}}</span>
            </li>
            <li>
              <label>{{$t('Country')}}:</label>
              <span>{{detail.country}}</span>
            </li>
            <li>
              <label>{{$t('Email')}}:</label>
              <span>{{detail.email}} </span>
            </li>
            <li>
              <label>{{$t('Status')}}:</label>
              <span>{{detail.status}}</span>
            </li>
            <li>
              <label>{{$t('Confirmation')}} #: </label>
              <span>{{detail.confirmation_number}}</span>
            </li>
            <li class="limiter"></li>
            <li>
              <label>{{$t('Special Request')}}: </label>
              <div class="request-box">
                <span v-for="(request, key) in detail.special_request" :key='key'>
                {{request}}
                </span>
              </div>

            </li>
            <li>
              <label>{{$t('ReMark')}}: </label>
              <span>{{detail.remark}}</span>
            </li>

          </ul>
          <div class="actions-toolbar">
            <a @click.prevent="$router.go(-1)" class="button secondry">{{$t('Back')}}</a>
            <button v-if="detail.status==='RESERVED'" class="primary" @click="cancelOrder(confirmation_number)">
              <span>{{$t('Cancel Booking')}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import util from '../../util'

  export default {
    name: "orderView",
    data() {
      return {
        confirmation_number: '',
        confirmNote: this.$t('Are you sure to cancel this booking?'),
        detail: '',
        fullLoading: true
      }
    },
    methods: {
      /**
       * get order view
       * **/
      getViews: function () {
        let vm = this;
        vm.confirmation_number = util.getUrlParam('confirmation_number');
        if (vm.confirmation_number) {
          vm.axios.get('/api/junket/order/detail', {
            params: {confirmation_number: vm.confirmation_number}
          }).then(function (res) {
              if (res.code === 200) {
                vm.detail = res.data;
              }

            }
          ).finally(function () {
            vm.fullLoading = false
          })
        }
      },

      /**
       * cancel order
       * **/
      cancelOrder(confirmNumber) {
        const h = this.$createElement;
        let vm = this;
        this.$msgbox({
          title: '',
          message:
            h('div', null, [
              h('p', null, vm.confirmNote),
              h('ul', null, [
                h('li', null, vm.detail.first_name + ' ' + vm.detail.last_name),
                h('li', null, vm.detail.hotel),
                h('li', null, util.dateFormat(vm.detail.arrival_date) + '-' + util.dateFormat(vm.detail.departure_date)),
                h('li', null, vm.detail.room_type)
              ]),
            ]),
          dangerouslyUseHTMLString: true,
          showCancelButton: true,
          confirmButtonText: this.$t('Yes'),
          cancelButtonText: this.$t('No'),
          type: 'warning',
          center: true
        }).then(() => {
          this.fullLoading = true
          this.axios.post('/api/junket/order/cancel', {
            confirmation_number: confirmNumber
          }).then(function (res) {
              if (res.code === 200) {
                vm.$message({
                  type: 'success',
                  message: res.msg
                });
                vm.getViews()
              } else {
                vm.$message({
                  type: 'error',
                  message: res.msg
                });
              }
            }
          ).finally(function () {

          })

        }).catch(() => {
        });
      },
    },
    created() {
      this.getViews()
    }
  }
</script>

